module.exports = __webpack_public_path__ + "img/emotion-style.27fa114.jpg";